import React from "react";
import WorkspaceInternalControls from "../../libraries/WorkspaceInternalControls";

interface BorrIndASInternalControlsProps {
  onBack?: () => void;
  setActiveSection?: (section: string) => void;
  controlsListSection?: string;
}

export default function BorrIndASInternalControls({ onBack, setActiveSection, controlsListSection }: BorrIndASInternalControlsProps) {
  return (
    <WorkspaceInternalControls
      workspaceName="Borrowings - Ind AS"
      onBack={onBack}
      setActiveSection={setActiveSection}
      controlsListSection={controlsListSection}
    />
  );
}

